import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import Select from "react-select";
import { lastModified, priority } from "../../core/common/selectoption/selectoption";
import TodoModal from "../../core/modals/todoModal";
import { all_routes } from "../router/all_routes";
import TooltipOption from "../../core/common/tooltipOption";
import { _get } from "../Utils/Helper";
import SyllabusItem, { SyllabusItemProps } from "./SyllabusItem";
// import SyllabusModal from "../../core/modals/SyllabusModal";

const Todo = () => {
  
  const _form = {
    query_type:"create",
    status:"",
  }
  const [form, setForm] = useState(_form)
  const [todos, setTodos] = useState<SyllabusItemProps[]>([]);

const type_arr = ['profile','home','messages','settings'];
const status_arr = ['Pending','Completed','Inprogress','Deleted']
const colors =  ['text-info','text-danger','text-warning','text-success']
  const getData = useCallback (() =>{
    _get(
      `task-todos?query_type=select&status=${form.status}`,
      (res) => {
        if (res.success && res.data.length) {
          console.log(res);
          setTodos(res.data);
        }
      },
      (err) => {
        console.error(err);
      }
    );
  },[form.status])

  useEffect(() => {
    getData();
  }, [getData]);

  const options = [
    { value: "bulk-actions", label: "Bulk Actions" },
    { value: "delete-marked", label: "Delete Marked" },
    { value: "unmark-all", label: "Unmark All" },
    { value: "mark-all", label: "Mark All" },
  ];
  const routes = all_routes;
  return (
    <>
      <div className="page-wrapper notes-page-wrapper">
        {/* {JSON.stringify(todos)} */}
        <div className="content pb-4">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3 pb-3 border-bottom position-relative">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Task/Todo</h3>
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Academic</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Todo
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#note-units"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Task
                </Link>
              </div>
            </div>
            <Link
              id="toggle_btn2"
              className="notes-tog position-absolute start-0 avatar avatar-sm rounded-circle bg-primary text-white"
              to="#"
            >
              <i className="fas fa-chevron-left" />
            </Link>
          </div>
          <div className="row">
            <div className="col-xl-3 col-md-12 sidebars-right theiaStickySidebar section-bulk-widget">
              <div className="stickybar">
                <div className="border rounded-3 mt-4 bg-white p-3">
                  <div className="mb-3 pb-3 border-bottom">
                    <h4 className="d-flex align-items-center">
                      <i className="ti ti-file-text me-2" />
                      Todo List
                    </h4>
                  </div>
                  <div className="border-bottom pb-3 ">
                    <div
                      className="nav flex-column nav-pills"
                      id="v-pills-tab"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      {status_arr.map((sts:string, index:number)=><button
                        className={`d-flex text-start align-items-center fw-semibold fs-15 nav-link mb-1`}
                        id={`v-pills-${type_arr[index]}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#v-pills-${type_arr[index]}`}
                        type="button"
                        role="tab"
                        aria-controls={`v-pills-${type_arr[index]}`}
                        aria-selected="false"
                        onClick={() => setForm((p)=>({...p, status: sts}))}
                        color={colors[index]}
                      >
                        <i className="ti ti-circle-check me-2" />
                        <span className={`text-${colors[index]}`}>{sts}</span>
                      </button>)}
                      
                    </div>
                  </div>
                 
                  {/* <div className="mt-3">
                    <div className="border-bottom px-2 pb-3 mb-3">
                      <h5 className="mb-2">Status</h5>
                      <div className="d-flex flex-column mt-2">
                        <Link to="#" className="text-info mb-2">
                          <span className="text-info me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Pending
                        </Link>
                        <Link to="#" className="text-danger mb-2">
                          <span className="text-danger me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Onhold
                        </Link>
                        <Link to="#" className="text-warning mb-2">
                          <span className="text-warning me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Inprogress
                        </Link>
                        <Link to="#" className="text-success">
                          <span className="text-success me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Completed
                        </Link>
                      </div>
                    </div>
                     <div className="px-2">
                      <h5 className="mb-2">Priority</h5>
                      <div className="d-flex flex-column mt-2">
                        <Link to="#" className="text-warning mb-2">
                          <span className="text-warning me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Medium
                        </Link>
                        <Link to="#" className="text-success mb-2">
                          <span className="text-success me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          High
                        </Link>
                        <Link to="#" className="text-danger">
                          <span className="text-danger me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Low
                        </Link>
                      </div>
                    </div> *
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-xl-9 budget-role-notes">
              <div className="bg-white rounded-3 d-flex align-items-center justify-content-between flex-wrap my-4 p-3 pb-0">
                <div className="d-flex align-items-center mb-3">
                  <div className="me-3">
                    <Select
                      options={options}
                      className="select"
                      classNamePrefix="react-select"
                    />
                  </div>
                  <Link to="#" className="btn btn-light">
                    Apply
                  </Link>
                </div>
                <div className="form-sort mb-3">
                  <i className="ti ti-filter feather-filter info-img ms-1" />
                  <Select
                    className="select"
                    classNamePrefix="react-select"
                    options={lastModified}
                    placeholder="Sort by Date"
                  />
                </div>
              </div>
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <div className="row">
                    <div className="col-lg-12">
                    {todos.length? todos?.map((todo)=> <SyllabusItem {...todo}/>):null}
                
                     
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row custom-pagination">
                <div className="col-md-12">
                  <div className="paginations d-flex justify-content-end">
                    <span>
                      <i className="fas fa-chevron-left" />
                    </span>
                    <ul className="d-flex align-items-center page-wrap">
                      <li>
                        <Link to="#" className="active">
                          1
                        </Link>
                      </li>
                      <li>
                        <Link to="#">2</Link>
                      </li>
                      <li>
                        <Link to="#">3</Link>
                      </li>
                      <li>
                        <Link to="#">4</Link>
                      </li>
                    </ul>
                    <span>
                      <i className="fas fa-chevron-right" />
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <TodoModal getData={getData}/>
    </>
  );
};

export default Todo;
